exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RaDZBQXbX2XR28pMKBhs7{color:#757575}.TTcPHmyq4Eh8b6-Kg4ct9{text-align:center;padding:40px 10px 40px 10px;color:#757575;border-bottom:1px solid #e0e0e0}.TTcPHmyq4Eh8b6-Kg4ct9 ._1JAJZsb_jwLH-qCBg6Haup{margin-bottom:5px;opacity:0.8}._2gSd_9zd8UG6_mvu6jWGhS{padding:10px;border-bottom:1px solid #e0e0e0}\n", ""]);

// Exports
exports.locals = {
	"light": "RaDZBQXbX2XR28pMKBhs7",
	"emptyState": "TTcPHmyq4Eh8b6-Kg4ct9",
	"emptyIcon": "_1JAJZsb_jwLH-qCBg6Haup",
	"circleSpinner": "_2gSd_9zd8UG6_mvu6jWGhS"
};